module.exports = __webpack_public_path__ + "static/media/20210401_214121_211_IMG_0054.7be9e6a8.jpg";